var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5F6A7D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2a4.5 4.5 0 100 9 4.5 4.5 0 000-9zM12 12.5c-4.173 0-7.227 2.794-8.06 6.501C3.69 20.112 4.6 21 5.6 21h12.803c.999 0 1.908-.888 1.659-1.999-.834-3.707-3.887-6.501-8.06-6.501z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGlkPSJQcm9wZXJ0eSAxPVBFUlNPTiI+CjxnIGlkPSJJY29uIj4KPHBhdGggZD0iTTEyIDJDOS41MTQ3MiAyIDcuNSA0LjAxNDcyIDcuNSA2LjVDNy41IDguOTg1MjggOS41MTQ3MiAxMSAxMiAxMUMxNC40ODUzIDExIDE2LjUgOC45ODUyOCAxNi41IDYuNUMxNi41IDQuMDE0NzIgMTQuNDg1MyAyIDEyIDJaIiBmaWxsPSIjNUY2QTdEIi8+CjxwYXRoIGQ9Ik0xMi4wMDA0IDEyLjVDNy44MjcxIDEyLjUgNC43NzM0NSAxNS4yOTM2IDMuOTQwMiAxOS4wMDEzQzMuNjkwNTcgMjAuMTEyIDQuNjAwMTQgMjEgNS41OTg4MiAyMUgxOC40MDJDMTkuNDAwNyAyMSAyMC4zMTAyIDIwLjExMiAyMC4wNjA2IDE5LjAwMTNDMTkuMjI3NCAxNS4yOTM2IDE2LjE3MzcgMTIuNSAxMi4wMDA0IDEyLjVaIiBmaWxsPSIjNUY2QTdEIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgPerson as ReactComponent };